import { Loader, LoaderProps } from "@progress/kendo-react-indicators";
import * as React from "react";

interface CircularProgressProps extends Omit<LoaderProps, "size"> {
  size?: number | "small" | "medium" | "large";
}

export const CircularProgress: React.FC<CircularProgressProps> = ({
  size,
  ...props
}) => {
  // Map Material UI size prop to Kendo Loader size
  const kendoSize =
    typeof size === "number"
      ? size <= 20
        ? "small"
        : size <= 40
          ? "medium"
          : "large"
      : size || "medium";

  return <Loader size={kendoSize} {...props} />;
};

export default CircularProgress;
